import { ChangeDetectionStrategy, Component, ElementRef, HostListener, inject, signal } from '@angular/core';
import { Router } from '@angular/router';

/**
 * The app's navigation menu: the button at the left of the header bar, and
 * the menu of sections that drops from it.
 */
@Component({
  selector: 'app-nav-menu',
  standalone: true,
  templateUrl: './nav-menu.component.html',
  styleUrl: './nav-menu.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class NavMenuComponent {
  private router = inject(Router);
  private elementRef = inject<ElementRef<HTMLElement>>(ElementRef);

  readonly open = signal(false);
  readonly onboardingOpen = signal(false);

  toggle(event: Event): void {
    event.stopPropagation();
    this.open.update(open => !open);
  }

  toggleOnboarding(): void {
    this.onboardingOpen.update(open => !open);
  }

  goTo(path: string): void {
    void this.router.navigate([path]);
    this.open.set(false);
  }

  @HostListener('document:click', ['$event'])
  onDocumentClick(event: Event): void {
    if (this.open() && !this.elementRef.nativeElement.contains(event.target as Node)) {
      this.open.set(false);
    }
  }

  @HostListener('document:keydown.escape')
  onEscape(): void {
    this.open.set(false);
  }
}
